import(/* webpackMode: "eager" */ "/home/runner/work/atlantic-dawn-monorepo/atlantic-dawn-monorepo/apps/fe/oauth-webapp/src/app/error.tsx");
